import React, { useEffect, useState } from 'react';

import { projectService } from '../services/projectService';

interface ProjectVisibilityDropdownProps {
  projectId?: string | null;
  isPublic: boolean;
  disabled?: boolean;
  onVisibilityChange?: (projectId: string | null, isPublic: boolean) => void;
}

export const ProjectVisibilityDropdown: React.FC<ProjectVisibilityDropdownProps> = ({
  projectId, isPublic, disabled = false, onVisibilityChange,
}) => {
  const [value, setValue] = useState(isPublic);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setValue(isPublic);
  }, [isPublic]);

  const handleChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const nextValue = event.target.value === 'public';

    if (nextValue === value || saving) return;

    const previousValue = value;
    setValue(nextValue);

    if (projectId) {
      setSaving(true);
      try {
        const response = await projectService.toggleVisibility(projectId, nextValue);
        setValue(response.is_public);
        onVisibilityChange?.(projectId, response.is_public);
      } catch {
        setValue(previousValue);
      } finally {
        setSaving(false);
      }
    } else {
      onVisibilityChange?.(null, nextValue);
    }
  };

  return (
    <label
      className="project-visibility-dropdown"
      onClick={(event) => event.stopPropagation()}
      title={value ? 'Project is Public' : 'Project is Private'}
    >
      <select
        aria-label="Project visibility"
        className="project-visibility-dropdown__select"
        disabled={disabled || saving}
        onChange={handleChange}
        value={value ? 'public' : 'private'}
      >
        <option value="public">Public</option>
        <option value="private">Private</option>
      </select>
    </label>
  );
};
